import FitAssistantStatusEnum from './FitAssistantStatusEnum';
import FitAssistantStatusIconEnum from './FitAssistantStatusIconEnum';
import Cookies from 'js-cookie';
import { IsProductPage } from './IsProductPage';
import FittingInstructionMovie from './FittingInstructionMovie';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initMobileSlider } from '../../ProductDetail';
import { getMercadoPaymentMessage } from '/Foundation/Common/code/Utils/PaymentUtils';
export const SetFitStatusForAllProducts = (fitAssistantStatus) => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')].filter(
    (x) => x.dataset.productType !== 'Accessory'
  );
  allProductCards.forEach((card) => {
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    compatibilityStatus.classList.remove('d-none');
    let indicator = card.querySelector('.fit-indicator');
    ResetFitIndicator(indicator);
    indicator.classList.add(fitAssistantStatus);
  });
};

export const getIconClassByFitAssistantStatus = (fitAssistantStatus) => {
  switch (fitAssistantStatus) {
    case FitAssistantStatusEnum.NoSelection:
      return FitAssistantStatusIconEnum.NoSelection;
    case FitAssistantStatusEnum.Confirmed:
      return FitAssistantStatusIconEnum.Confirmed;
    case FitAssistantStatusEnum.NoFit:
      return FitAssistantStatusIconEnum.NoFit;
    case FitAssistantStatusEnum.RackMounting:
      return FitAssistantStatusIconEnum.Confirmed;
    default:
      return FitAssistantStatusIconEnum.Unconfirmed;
  }
};
export const ResetFitStatusForAllProducts = () => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')];
  allProductCards.forEach((card) => {
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    let indicator = card.querySelector('.fit-indicator');
    ResetFitIndicator(indicator);
    compatibilityStatus.classList.add('d-none');

    const dbg__cartBtnContainer = card.querySelector('.dbg__cartBtnContainer');
    if (dbg__cartBtnContainer) dbg__cartBtnContainer.classList.add('d-none');

    //reset price
    if (window._THULEDATA?.isExtranet) {
      var rrpElement = card.querySelector('.RRP-value');
      if (rrpElement) rrpElement.innerHTML = rrpElement.dataset.defaultprice;
    } else {
      var priceElement = card.querySelector('.price-value');
      if (priceElement) priceElement.innerHTML = priceElement.dataset.defaultprice;

      var discountPriceElement = card.querySelector('.discount-price-value');
      if (discountPriceElement) discountPriceElement.innerHTML = discountPriceElement.dataset.defaultprice;
    }
    setSolutionProductListItemImage(card, null);
  });
  if (!IsProductPage && typeof resetIsotopeLayout != 'undefined') resetIsotopeLayout();
};

const ResetFitIndicator = (fitIndicatorElement) => {
  if (!fitIndicatorElement) return;
  fitIndicatorElement.classList.remove(
    FitAssistantStatusEnum.Confirmed,
    FitAssistantStatusEnum.Unconfirmed,
    FitAssistantStatusEnum.NoFit,
    FitAssistantStatusIconEnum.Confirmed,
    FitAssistantStatusIconEnum.Unconfirmed,
    FitAssistantStatusIconEnum.NoFit
  );
};

export const setSolutionProductListItemImage = (pli, matchingProduct) => {
  if (!pli) return;
  const pimId = pli.getAttribute('data-pimid');
  if (!pimId) return;
  const images = pli.querySelectorAll(`.img-container img[data-pimid='${pimId}'][data-defaultimage]`);
  images.forEach((image) => {
    if (matchingProduct && matchingProduct.ImageUrl) {
      image.src = matchingProduct.ImageUrl;
    } else {
      const defaultUrl = image.getAttribute('data-defaultimage');

      if (defaultUrl) image.src = defaultUrl;
    }
  });
};

export const SetFitStatusForConfirmedFits = (uniqueProductCardConfirmedFits, noFitIds, initialData = null) => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')];
  allProductCards.forEach((card) => {
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    compatibilityStatus.classList.remove('d-none');
    let indicator = card.querySelector('.fit-indicator');
    ResetFitIndicator(indicator);

    const dbg_addToCart = card.querySelector('.dbg__cartBtnContainer');
    if (uniqueProductCardConfirmedFits.includes(card)) {
      indicator.classList.add(FitAssistantStatusEnum.Confirmed, FitAssistantStatusIconEnum.Confirmed);
      if (
        dbg_addToCart &&
        dbg_addToCart.querySelector('.dbg_cart_btn') &&
        _THULEDATA?.FitAssistant &&
        _THULEDATA._buyersGuide
      )
        dbg_addToCart.classList.remove('d-none');
      card.dataset.sortFit = 1;
    } else if (card.dataset.productType !== 'Accessory') {
      const isConfirmedNofit =
        (noFitIds && noFitIds.indexOf(card.dataset.pimid) > -1) || initialData?.DisableUnconfirmed;
      const iconClass = getIconClassByFitAssistantStatus(
        isConfirmedNofit ? FitAssistantStatusEnum.NoFit : FitAssistantStatusEnum.Unconfirmed
      );
      if (isConfirmedNofit) {
        indicator.classList.add('nofit', iconClass);
        card.dataset.sortFit = -1;
      } else {
        indicator.classList.add('unconfirmed', iconClass);
        card.dataset.sortFit = 0;
      }

      if (dbg_addToCart) dbg_addToCart.classList.add('d-none');
    }
  });
  triggerSortOnPLP();
  if (!IsProductPage && typeof resetIsotopeLayout != 'undefined') resetIsotopeLayout();
};

const triggerSortOnPLP = () => {
  const sortSection = document.querySelector('.sorting-section');
  if (!sortSection) return;

  const event = new CustomEvent('triggerSort', { detail: 'fit' });
  let count = 0;
  const triggerCheck = setInterval(() => {
    if (sortSection.hasAttribute('data-triggersort') || count >= 19) {
      sortSection.dispatchEvent(event);
      clearInterval(triggerCheck);
    }
    count++;
  }, 100);
};

export const UpdateFitAssistantPriceAndATC = (productIds) => {
  fetch('/api/sitecore/fitguide/getfitguideatcandprice', {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ ProductIds: productIds }),
  })
    .then((resp) => resp.json())
    .then((data) => {
      setAddToCartButton(data.Button, true);
      setPricePDP(data.PriceContainer);
      refreshPlacements(data.PriceContainer);
    });
};

export const setAddToCartBtnForDBG = (pli, matchingProduct) => {
  if (!pli || !matchingProduct || !_THULEDATA?._buyersGuide) return;
  var productIdsElement = pli.querySelector('.product-add-to-cart .product-ids-for-solution');
  if (productIdsElement) {
    productIdsElement.value = matchingProduct.ProductIds.join(',');
  }
};

export const setAddToCartButton = (button, showSolutionAddToCartBtn) => {
  if (!button) return;

  // 7 = B2CDisabled, do now show any button at all.
  if (button.Status == 7) return;

  var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');
  if (addToCartArea) {
    let solutionIdsElement = addToCartArea.querySelector('.product-ids-for-solution');
    solutionIdsElement.value = button.ProductIdsForSolution;
    if (!showSolutionAddToCartBtn) return;

    if (_THULEDATA.FitGuideRacksData) {
      setAddToCartBtnForFitGuideRacks(button);
    } else {
      setSolutionAddToCartBtnVisibility(button);
    }
  }
};

const setAddToCartBtnForFitGuideRacks = (addToCartButton) => {
  if (!addToCartButton && !IsProductPage) return;
  const addToCartBtnElement = document.querySelector('.product-add-to-cart button:not(.d-none)');
  const status = document.querySelector('.product-add-to-cart .tpd-product-stock-status');
  if (!addToCartBtnElement || !status) return;

  addToCartBtnElement.innerHTML = addToCartButton.ButtonText;
  status.innerHTML = addToCartButton.ButtonSubText;
  if (!addToCartButton.IsInStock || !addToCartButton.IsSellable) {
    addToCartBtnElement.classList.remove('thule-btn-shop');
    addToCartBtnElement.classList.add('thule-btn-secondary');
    addToCartBtnElement.classList.add('disabled');
  } else {
    addToCartBtnElement.classList.add('thule-btn-shop');
    addToCartBtnElement.classList.remove('thule-btn-secondary');
    addToCartBtnElement.classList.remove('disabled');
  }
};

const setSolutionAddToCartBtnVisibility = (addToCartButton) => {
    if (!addToCartButton) return;
    var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');
    if (addToCartArea) {
        let buyableBtn = addToCartArea.querySelector('.solution-btn.buyable button');
        let notBuyableBtn = addToCartArea.querySelector('.solution-btn.not-buyable button');
        let favoriteButtonContainer = addToCartArea.closest(".pdp_ButtonContainer")?.querySelector(".productFavoriteButtonContainer");
        if (!buyableBtn || !notBuyableBtn) return;

    // Status: 0 = sellable, 1 = AvailableToPromiseLimitFulfilled, 2 = OutOfStock
    if (addToCartButton.Status <= 2) {
      addToCartArea.querySelector('.tpd-product-stock-status.single-product')?.classList.add('d-none');

      addToCartArea.querySelector('.buyable .tpd-product-stock-status span').textContent =
        addToCartButton.ButtonSubText;
      addToCartArea.querySelector('.not-buyable .tpd-product-stock-status span').textContent =
        addToCartButton.ButtonSubText;
    }

        if (
            addToCartButton.IsSellable &&
            (addToCartButton.IsInStock || (!addToCartButton.IsInStock && addToCartButton.IsAvailableToPromiseFulfilled))
        ) {
            buyableBtn.textContent = addToCartButton.ButtonText;
            buyableBtn.parentElement.classList.remove('d-none');
            notBuyableBtn.parentElement.classList.add('d-none');
        } else {
            notBuyableBtn.textContent = addToCartButton.ButtonText;
            notBuyableBtn.parentElement.classList.remove('d-none');
            buyableBtn.parentElement.classList.add('d-none');
        }
        if (favoriteButtonContainer && _THULEDATA?.enableFavorites)
            favoriteButtonContainer.classList.remove("d-none");
        //if making solution add to cart btn visible we hide the default btn to prevent duplicate btns
        const defaultAddToCartBtn = document.querySelector(
            '.product-detail__buy-area .product-add-to-cart > button:not(.roof-rack-btn, .d-none)'
        );
        if (defaultAddToCartBtn) defaultAddToCartBtn.classList.add('d-none');
        addToCartArea.querySelector('.atc-stockstatus').value = addToCartButton.StockStatusText;
    }
};
export const setPricePDP = (priceContainer) => {
  if (!priceContainer) return;

  var priceArea = document.querySelector('.product-detail__buy-area .price');
  if (priceArea === null) return;
  var priceElement = priceArea.querySelector('.price-value');
  var discountPriceElement = priceArea.querySelector('.discount-price-value');

  priceArea.querySelector('.ga-price').innerHTML = priceContainer.Price;
  priceArea.querySelector('.ga-discount-price').innerHTML = priceContainer.DiscountPrice;

  if (window._THULEDATA?.isExtranet) {
    var rrpElement = priceArea.querySelector('.RRP-value');
    if (rrpElement) rrpElement.innerHTML = priceContainer.PriceFormatted;
    if (!window._THULEDATA?.FitAssistant?.IsRooftopTents) {
      if (priceElement) priceElement.innerHTML = '';
    }
  } else {
    priceElement.innerHTML = priceContainer.PriceFormatted;
    setAddToCartButtonPrice(priceContainer);
    if (priceContainer.DiscountPrice > 0) {
      priceElement.classList.add('line-through-text');
      discountPriceElement.innerHTML = priceContainer.DiscountPriceFormatted;
    } else {
      priceElement.classList.remove('line-through-text');
      setMercadoMessage(priceContainer.Price);
      discountPriceElement.innerHTML = '';
    }
  }
};

const setAddToCartButtonPrice = (priceContainer) => {
  if (!priceContainer) return;

  var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');

  if (!addToCartArea) return;

  addToCartArea.querySelector('.atc-original-price').value = priceContainer.Price;
  addToCartArea.querySelector('.atc-original-price-formatted').value = priceContainer.PriceFormatted;

  if (priceContainer.DiscountPrice > 0) {
    addToCartArea.querySelector('.atc-product-price').value = priceContainer.DiscountPriceFormatted;
    addToCartArea.querySelector('.atc-product-price-nocurrency').value = priceContainer.DiscountPrice;
  } else {
    addToCartArea.querySelector('.atc-product-price').value = priceContainer.PriceFormatted;
    addToCartArea.querySelector('.atc-product-price-nocurrency').value = priceContainer.Price;
  }
};

const setMercadoMessage = (amount) => {
  const mercadoBaseURL = document.querySelector('#mercadoBaseURL')?.value;
  const mercadoAPIKey = document.querySelector('#mercadoAPIKey')?.value;
  if (mercadoBaseURL && mercadoAPIKey) getMercadoPaymentMessage(mercadoBaseURL, mercadoAPIKey, amount);
};

export const refreshPlacements = (priceContainer) => {
  if (!priceContainer) return;
  if (document.getElementsByTagName('afterpay-placement')[0])
    document.getElementsByTagName('afterpay-placement')[0].setAttribute('data-amount', priceContainer.Price);
  if (document.getElementsByTagName('klarna-placement')[0])
    document
      .getElementsByTagName('klarna-placement')[0]
      .setAttribute('data-purchase-amount', Math.round(priceContainer.Price * 100));
  if (window.KlarnaOnsiteService) window.Klarna.OnsiteMessaging.refresh();
};

export const isConfirmedNoFit = (nofitIds, productId) => {
  if (!nofitIds) return false;
  return nofitIds.indexOf(productId) > -1;
};

export const setQueryFromSearchParameters = (cookieName, parameters) => {
  const url = new URL(document.location);
  const setSearchParameters = parameters
    .map((item) => `${item.parameterName}:${item.value}|${encodeURI(item.text)}`)
    .join(',');
  url.searchParams.set(cookieName, setSearchParameters);
  history.replaceState(null, null, url.toString());
};

export const getSearchParametersFromQuery = (cookieName) => {
  const regexS = '[\\?&]' + cookieName + '=([^&#]*)';
  const regex = new RegExp(regexS);
  const results = regex.exec(window.location.search);
  if (results === null) {
    return null;
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

export const getAdditionalFilterForOptions = (step, additionalFilters) => {
  if (!additionalFilters || !step.FilterOptions) return null;
  return JSON.stringify(additionalFilters);
};

export const getAdditionalFilterForProductSearch = (step, additionalFilters) => {
  if (!additionalFilters || !step.FilterProductResult) return null;
  return JSON.stringify(additionalFilters);
};
